import React from "react";
import { getLocalizedStrings } from "./centralizedLocalizedString";
import PreferenceBanner from "./common/PreferenceBanner";
import NeedToUpdateCustomerInfo from "./CustomerPreferences/NeedToUpdateCustomerInfo";
import CustomerPreference from "../Centralized/CustomerPreferences/CustomerPreference";
import ErrorCard from "./common/ErrorCard";
import AccountPreference from "./AccountPreferences/AccountPrefence";
import AccountPreferenceContainer from "./AccountPreferences/AccountPreferenceContainer";

class PreferenceCenterHelper extends React.Component {
    constructor(props) {
        super(props);
        this.strings = getLocalizedStrings("CentralizedContainer");
        this.state = {
            staticContent: {
                pb:{subTxtId: 'pb-txt', subTxt: '', infoTxtId: 'pb-popup', infoPopupTxt: ''},
                ea:{subTxtId: 'ea-txt', subTxt: '', infoTxtId: 'ea-popup', infoPopupTxt: ''},
                rm:{subTxtId: 'rmo-txt', subTxt: '', infoTxtId: 'rmo-popup', infoPopupTxt: ''},
                ba:{subTxtId: 'ba-txt', subTxt: '', infoTxtId: 'ba-popup', infoPopupTxt: ''},
                cpp:{subTxtId: 'cpp-txt', subTxt: '', infoTxtId: 'cpp-popup', infoPopupTxt: ''},
                notiLang:{subTxtId: 'nl-txt', subTxt: ''},
                sceUpdates:{subTxtId: 'updates-txt', subTxt: ''}
            }
        };
    }
    componentDidMount(){
        if(app.appService.getUserInfo().profileData.profile.userType==="WEBUSER" || app.appService.getUserInfo().profileData.profile.userType==="CI"){
            app.appUtil.navigateTo('/mysce/websettings#preferences');
        }
    }
    componentWillMount() {
        app.contentService.getContent("CPC_CONTENT").then(
            (response) => {
                let staticContent = response[0].body;
                let updatedSate = {...this.state};
                updatedSate.staticContent.pb = this.getStaticContent(staticContent, updatedSate.staticContent.pb);
                updatedSate.staticContent.ea = this.getStaticContent(staticContent, updatedSate.staticContent.ea);
                updatedSate.staticContent.rm = this.getStaticContent(staticContent, updatedSate.staticContent.rm);
                updatedSate.staticContent.ba = this.getStaticContent(staticContent, updatedSate.staticContent.ba);
                updatedSate.staticContent.cpp = this.getStaticContent(staticContent, updatedSate.staticContent.cpp);
                updatedSate.staticContent.notiLang = this.getStaticContent(staticContent, updatedSate.staticContent.notiLang);
                updatedSate.staticContent.sceUpdates = this.getStaticContent(staticContent, updatedSate.staticContent.sceUpdates);
                this.setState(updatedSate);
            },
            (error) => {
                app.logger.getLogger().info("error error::" + JSON.stringify(error));
            }
        );
    }
    
    getStaticContent(staticContent, module){
        let subTxtRegex = new RegExp('<div id="'+module.subTxtId+'">([^`]*?)</div>', "g");
        module.subTxt = (staticContent).match(subTxtRegex);
        if(module.infoTxtId) {
            let infoRegex = new RegExp('<div id="'+module.infoTxtId+'">([^`]*?)</div>', "g");             
            module.infoPopupTxt = (staticContent).match(infoRegex);
        }
        return  module;
    }

    render() {
        let displayBanner = (this.props.noBanner!==undefined?!this.props.noBanner:true);
        //alert(JSON.stringify(this.props.cpcData.customerDetails));
        return (
            //This change is for ANP2-294 to remove horizontal scroll
            <div className="col-xs-12">
                { !this.props.bpMatch && this.props.errorCard ? null : (
                    displayBanner ? <PreferenceBanner message={this.strings.BannerLabel} />:null
                )}
                {this.props.errorCard ? (
                    <ErrorCard
                        bpErrorCntr={this.props.bpErrorCntr}
                        bpMatch={this.props.bpMatch}
                        firstName={this.props.profileData.firstName}
                        lastName={this.props.profileData.lastName}
                        emailId={this.props.profileData.email}
                        profileData={this.props.profileData}
                        disp={this.props.disp}
                        bpErrorMsgSwitch={this.props.bpErrorMsgSwitch}
                        retrieveInputData={this.props.retrieveInputData}
                        message={this.strings.ErrorMainText}
                        bpMessageOne={this.strings.ErrorBpTextOne}
                        bpMessageTwo={this.strings.ErrorBpTextTwo}
                        subMessage={this.strings.ErrorSubText}
                        mainMessage={this.strings.ErrorMainText}
                    />
                ) : null}
                {this.props.preferenceContent ? (
                    <div className="row">
                        <div className="col-md-6">
                    {this.props.cpcData.accountType === this.strings.accountTypeSingle ? (
                            <AccountPreference
                                data={this.props.cpcData}
                                customerData={this.props.cpcData.customerDetails}
                                isWebUser={this.props.webUser}
                                handleRefreshAccPref={this.props.handleRefreshAccPref.bind(this)}
                                errorResponse={this.props.cpcData.errorResponseVo}
                                staticContent={this.state.staticContent}
                                billingRateType={this.props.billingRateType}
                            />
                        ) : (
                            <AccountPreferenceContainer
                  cpcData={this.props.cpcData}
                  customerData={this.props.cpcData.customerDetails}
                  isWebUser={this.props.webUser}
                  isMultiAcc={1}
                  handleRefreshAccPref={this.props.handleRefreshAccPref.bind(this)}
                  errorResponse={this.props.cpcData.errorResponseVo}
                  getMyAccountDetails={this.props.getMyAccountDetails}
                  getWebUserDetails={this.props.getWebUserDetails}
                  staticContent={this.state.staticContent}
                  billingRateType={this.props.billingRateType}
                />
              )}
                        </div>
                        <div className="col-md-6">
                            <div>
                                <CustomerPreference
                                    res={this.props.cpcData}
                                    handleMarketingPref={this.props.handleMarketingPref.bind(this)}
                                    errorResponse={this.props.cpcData.errorResponseVo}
                                    handleRefreshMkpr={this.props.handleRefreshMkpr.bind(this)}
                                    marketRefresh={this.props.marketRefresh}
                                    marketregrefresh={this.props.marketregrefresh}
                                    handlerefreshtxt={this.props.handlerefreshtxt.bind(this)}
                                    guestUser={this.props.guestUser}
                                    staticContent={this.state.staticContent}
                                />
                            </div>
                            <NeedToUpdateCustomerInfo
                                content={this.state.staticContent}
                                firstName={this.props.profileData.firstName}
                                lastName={this.props.profileData.lastName}
                                emailId={this.props.profileData.email}
                                language={this.props.profileData.preferredLanguage}
                                guestUser={this.props.guestUser}
                            />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }
}

export default PreferenceCenterHelper;
